<div class="container">

  @if (!showForm) {
    <div class="row mb-1">
      <div class="col-md-12 w-100">
        <div class="pull-right">
          <button class="btn btn-primary" (click)="add()"><i class="fa fa-plus me-1"></i>Neuer Upload</button>
        </div>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-md-12">
      @if (showForm) {
        <app-upload-form
          [form]="form"
          [mode]="formMode"
          (saved)="savedForm($event)"
          (canceled)="showForm = false">
        </app-upload-form>
      }
    </div>
  </div>

  @if (!showForm) {
    <p-table class="report-tables" [value]="uploads">
      <ng-template pTemplate="header">
        <tr>
          <th>Bezeichnung</th>
          <th>Dateiname</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{row.description}}</td>
          <td>{{row.fileName}}</td>
          <td>
            <button (click)="edit(row)" class="btn btn-xs btn-default">
              <i class="fa fa-pencil"></i>
            </button>
            <button (click)="showDeleteDialog(row)" class="btn btn-xs btn-default">
              <i class="fa fa-trash"></i>
            </button>
            <button class="btn btn-xs btn-default" (click)="download(row)" title="Upload herunterladen">
              <i class="fa fa-download"></i>
            </button>
            @if (isPreviewable(row)) {
              <button (click)="preview(row)" class="btn btn-xs btn-default">
                <i class="fa fa-eye"></i>
              </button>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<p-confirmDialog
  [key]="dialogKey"
  [style]="{width: '425px'}"
  #cd>
  <p-footer>
    @if (uploadToDelete?.owner == MyMercatusOwner.MyMercatusUser) {
      <div>
        <input style="width: calc(100% - 20px); margin-bottom: 10px; margin-left: 10px;" id="input" type="text" [(ngModel)]="deleteReason" placeholder="Grund (optional)"/>
      </div>
    }
    <button class="btn btn-default" (click)="cd.reject()">Behalten</button>
    <button class="btn btn-danger" (click)="cd.accept()"><i class="fa fa-trash-o"></i> Löschen</button>
  </p-footer>
</p-confirmDialog>

@if (previewRecord && previewUrl) {
  <p-dialog [header]="previewRecord.description" [modal]="true" [(visible)]="showPreview" [style]="{width: '50vw'}">
    @if (isPdf(previewRecord)) {
      <object class="upload-preview-pdf" [attr.data]="previewUrl" type="application/pdf">
      </object>
    }
    @if (isImage(previewRecord)) {
      <img [src]="previewUrl" [alt]="previewRecord.description" class="upload-preview-image" />
    }
  </p-dialog>
}
